module.exports = __webpack_public_path__ + "static/media/resize.0c62c0c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/resize.svg
// module id = 277
// module chunks = 0